import { unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "grid gap-5 sm:grid-cols-2"
}
const _hoisted_2 = { key: 1 }
const _hoisted_3 = { class: "text-sm text-gray-900" }

import { useRouter } from 'vue-router'
import { useStore } from 'vuex'

import InputField from '@/components/neue/InputField'
import NeueButton from '@/components/neue/NeueButton'
import SettingsSection from '@/components/neue/SettingsSection.vue'
import { useSettingsAccess } from '@/composables/useSettingsAccess'
import { resetSettingsForm, useSettingsForm } from '@/composables/useSettingsForm'
import { signOut } from '@/helpers/signOut'
import convertEmailService from '@/services/convertEmail.service'
import SettingsShell from '@/view/settings/SettingsShell.vue'


export default {
  __name: 'SettingsAccount',
  setup(__props) {

const store = useStore()
const router = useRouter()

const { systemUserId, currentUserEmail } = useSettingsAccess()
const { values, editing } = useSettingsForm()

const logOut = () => {
  convertEmailService.clear()
  resetSettingsForm()
  signOut({ store, router })
}

return (_ctx, _cache) => {
  return (_openBlock(), _createBlock(SettingsShell, null, {
    default: _withCtx(() => [
      _createVNode(SettingsSection, {
        title: "Your details",
        description: "How your team sees you, and the address you sign in with."
      }, {
        default: _withCtx(() => [
          (_unref(systemUserId))
            ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createVNode(_unref(InputField), {
                  modelValue: _unref(values).systemUserFullName,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => ((_unref(values).systemUserFullName) = $event)),
                  name: "Full name",
                  placeholder: "Full name",
                  onInput: _cache[1] || (_cache[1] = $event => (_unref(editing).systemUserFullName = true))
                }, null, 8, ["modelValue"]),
                _createVNode(_unref(InputField), {
                  modelValue: _unref(values).systemUserEmail,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => ((_unref(values).systemUserEmail) = $event)),
                  name: "Email",
                  type: "email",
                  placeholder: "michael@bluthcompany.com",
                  onInput: _cache[3] || (_cache[3] = $event => (_unref(editing).systemUserEmail = true))
                }, null, 8, ["modelValue"])
              ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_2, [
                _cache[4] || (_cache[4] = _createElementVNode("p", { class: "text-sm font-semibold text-gray-700 mb-1" }, "Signed in as", -1)),
                _createElementVNode("p", _hoisted_3, _toDisplayString(_unref(currentUserEmail)), 1),
                _cache[5] || (_cache[5] = _createElementVNode("p", { class: "mt-1 text-[13px] leading-relaxed text-gray-500" }, [
                  _createTextVNode(" Contact "),
                  _createElementVNode("a", {
                    href: "mailto:team@bottle.com",
                    class: "underline"
                  }, "team@bottle.com"),
                  _createTextVNode(" to change it. ")
                ], -1))
              ]))
        ]),
        _: 1
      }),
      _createVNode(SettingsSection, {
        title: "Session",
        description: "Sign out of Bottle on this browser.",
        flush: ""
      }, {
        default: _withCtx(() => [
          _cache[7] || (_cache[7] = _createElementVNode("p", { class: "text-sm font-semibold text-gray-700" }, "Log out of Bottle", -1)),
          _createVNode(_unref(NeueButton), {
            type: "secondary",
            onClick: logOut
          }, {
            default: _withCtx(() => [...(_cache[6] || (_cache[6] = [
              _createTextVNode("Log out", -1)
            ]))]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

}